import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import Navbar from '../../components/ALLJsx/Navbar';
import Footer from '../../components/ALLJsx/Footer';
import { FAQ_CATEGORIES } from '../../data/faqSupportContent';
import { FaqExpertSection } from './FaqSupportShared';
import '../AllCss/FaqSupport.css';

function FaqSupport() {
  const { t } = useLocale();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="faq-page">
      <Navbar />

      <section className="faq-hub-main" aria-labelledby="faq-hub-title">
        <div className="faq-shell faq-hub-shell">
          <header className="faq-hub-head">
            <h1 id="faq-hub-title" className="faq-hub-title">{t('faqSupport.heroTitle')}</h1>
          </header>

          <div className="faq-hub-topics">
            <p className="faq-hub-eyebrow">{t('faqSupport.browseByTopic')}</p>
            <div className="faq-topic-grid">
              {FAQ_CATEGORIES.map(({ id, icon: Icon }) => (
                <Link key={id} to={`/faq-support/${id}`} className="faq-topic-tile">
                  <span className="faq-topic-tile-icon" aria-hidden>
                    <Icon size={20} strokeWidth={2.25} />
                  </span>
                  <span className="faq-topic-tile-label">{t(`faqSupport.categories.${id}`)}</span>
                  <ChevronRight className="faq-topic-tile-arrow" size={16} strokeWidth={2.5} aria-hidden />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <FaqExpertSection />
      <Footer />
    </div>
  );
}

export default FaqSupport;
